import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

// GET ALL
export const fetchInvestigation = createAsyncThunk(
  "role/fetchInvestigation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.GET_MASTER_INVESTIGATION
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// CREATE
export const createInvestigation = createAsyncThunk(
  "role/createInvestigation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_MASTER_INVESTIGATION,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// UPDATE
export const updateInvestigation = createAsyncThunk(
  "role/updateInvestigation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_MASTER_INVESTIGATION,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// DELETE
export const deleteInvestigation = createAsyncThunk(
  "role/deleteInvestigation",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.delete(
        `${API_ENDPOINTS.DELETE_MASTER_INVESTIGATION}?id=${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const InvestigationSlice = createSlice({
  name: "Investigation",
  initialState: {
    fetch: { data: [], loading: false, error: null },
    create: { data: null, loading: false, error: null },
    update: { data: null, loading: false, error: null },
    delete: { data: null, loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchInvestigation.pending, (state) => {
        state.fetch.loading = true;
        state.fetch.error = null;
      })
      .addCase(fetchInvestigation.fulfilled, (state, action) => {
        state.fetch.loading = false;
        state.fetch.data = action.payload || [];
      })
      .addCase(fetchInvestigation.rejected, (state, action) => {
        state.fetch.loading = false;
        state.fetch.error = action.payload;
      })

      // CREATE
      .addCase(createInvestigation.pending, (state) => {
        state.create.loading = true;
        state.create.error = null;
      })
      .addCase(createInvestigation.fulfilled, (state, action) => {
        state.create.loading = false;
        state.create.data = action.payload;
      })
      .addCase(createInvestigation.rejected, (state, action) => {
        state.create.loading = false;
        state.create.error = action.payload;
      })

      // UPDATE
      .addCase(updateInvestigation.pending, (state) => {
        state.update.loading = true;
        state.update.error = null;
      })
      .addCase(updateInvestigation.fulfilled, (state, action) => {
        state.update.loading = false;
        state.update.data = action.payload;
      })
      .addCase(updateInvestigation.rejected, (state, action) => {
        state.update.loading = false;
        state.update.error = action.payload;
      })

      // DELETE
      .addCase(deleteInvestigation.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteInvestigation.fulfilled, (state, action) => {
        state.delete.loading = false;
        state.delete.data = action.payload;
      })
      .addCase(deleteInvestigation.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.error = action.payload;
      });
  },
});

export default InvestigationSlice.reducer;
